import commonSlice from '@/state/common.slice';
import store from '@/state/store';

export default async () => {
  store.dispatch(commonSlice.actions.markNotificationsAsDelivered());
};